<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newGLDebtCtrl">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newGLDebtCtrl">Create New GL Account No. Interface for Debtors Control</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Review GL Account No. Interface for Debtors Control</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query GL Account No. Interface for Debtors Control</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-container fluid grid-list-sm>
            <v-layout row>
              <v-flex xs4>
                <v-text-field
                  v-model="glDebtCtrlForm.branch"
                  :label="labels.branch"
                  :error-messages="errors.collect('branch')"
                  data-vv-name="branch"
                  :data-vv-as="labels.branch"
                  v-validate="'required|max:4'"
                  :disabled="!newGLDebtCtrl"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('branch')"
                  @change="doCheck('branch')"
                  :hint="glDebtCtrlForm.brnDesc"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="glDebtCtrlForm.fund"
                  :label="labels.fund"
                  :error-messages="errors.collect('fund')"
                  data-vv-name="fund"
                  :data-vv-as="labels.fund"
                  v-validate="'max:4'"
                  :disabled="!newGLDebtCtrl"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('fund')"
                  @change="doCheck('fund')"
                  :hint="glDebtCtrlForm.fundDesc"
                  persistent-hint
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="glDebtCtrlForm.acctNoSfx"
                  :label="labels.acctNoSfx"
                  :error-messages="errors.collect('acctNoSfx')"
                  data-vv-name="acctNoSfx"
                  :data-vv-as="labels.acctNoSfx"
                  v-validate="'max:4'"
                  :disabled="!newGLDebtCtrl"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('acctNoSfx')"
                  @change="doCheck('acctNoSfx')"
                  :hint="glDebtCtrlForm.acctNoSfxDesc"
                  persistent-hint
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-spacer class="mt-3"></v-spacer>
            <v-card-title>
              <div class="body-2">GL Account No. for</div>
            </v-card-title>
            <v-layout>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="glDebtCtrlForm.glAcctNoDebtCtrl"
                  :label="labels.glAcctNoDebtCtrl"
                  :error-messages="errors.collect('glAcctNoDebtCtrl')"
                  data-vv-name="glAcctNoDebtCtrl"
                  :data-vv-as="labels.glAcctNoDebtCtrl"
                  v-validate="'max:16'"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('glAcctNoDebtCtrl')"
                  @change="doCheckGLAcctNo('glAcctNoDebtCtrl')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="glDebtCtrlForm.glAcctNoDiffEx"
                  :label="labels.glAcctNoDiffEx"
                  :error-messages="errors.collect('glAcctNoDiffEx')"
                  data-vv-name="glAcctNoDiffEx"
                  :data-vv-as="labels.glAcctNoDiffEx"
                  v-validate="'max:16'"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('glAcctNoDiffEx')"
                  @change="doCheckGLAcctNo('glAcctNoDiffEx')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="glDebtCtrlForm.glAcctNoRevalue"
                  :label="labels.glAcctNoRevalue"
                  :error-messages="errors.collect('glAcctNoRevalue')"
                  data-vv-name="glAcctNoRevalue"
                  :data-vv-as="labels.glAcctNoRevalue"
                  v-validate="'max:16'"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('glAcctNoRevalue')"
                  @change="doCheckGLAcctNo('glAcctNoRevalue')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="glDebtCtrlForm.glAcctNoWoff"
                  :label="labels.glAcctNoWoff"
                  :error-messages="errors.collect('glAcctNoWoff')"
                  data-vv-name="glAcctNoWoff"
                  :data-vv-as="labels.glAcctNoWoff"
                  v-validate="'max:16'"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('glAcctNoWoff')"
                  @change="doCheckGLAcctNo('glAcctNoWoff')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="glDebtCtrlForm.glAcctNoInGst"
                  :label="labels.glAcctNoInGst"
                  :error-messages="errors.collect('glAcctNoInGst')"
                  data-vv-name="glAcctNoInGst"
                  :data-vv-as="labels.glAcctNoInGst"
                  v-validate="'max:16'"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('glAcctNoInGst')"
                  @change="doCheckGLAcctNo('glAcctNoInGst')"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryMode"
                  v-model="glDebtCtrlForm.glAcctNoOutGst"
                  :label="labels.glAcctNoOutGst"
                  :error-messages="errors.collect('glAcctNoOutGst')"
                  data-vv-name="glAcctNoOutGst"
                  :data-vv-as="labels.glAcctNoOutGst"
                  v-validate="'max:16'"
                  append-icon="mdi-magnify"
                  @click:append="doHelplist('glAcctNoOutGst')"
                  @change="doCheckGLAcctNo('glAcctNoOutGst')"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-flex xs6>
              <v-text-field
                :readonly="queryMode"
                v-model="glDebtCtrlForm.glAcctNoInstal"
                :label="labels.glAcctNoInstal"
                :error-messages="errors.collect('glAcctNoInstal')"
                data-vv-name="glAcctNoInstal"
                :data-vv-as="labels.glAcctNoInstal"
                v-validate="'max:16'"
                append-icon="mdi-magnify"
                @click:append="doHelplist('glAcctNoInstal')"
                @change="doCheckGLAcctNo('glAcctNoInstal')"
              ></v-text-field>
            </v-flex>
            <v-layout row wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ glDebtCtrlForm.createdBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ glDebtCtrlForm.createdDate | formatDate }}</div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="!newGLDebtCtrl">
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ glDebtCtrlForm.modifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ glDebtCtrlForm.modifiedDate | formatDate }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-btn class="mr-2" color="error" @click="doCancel">
          <span>Cancel</span>
          <v-icon right dark>mdi-cancel</v-icon>
        </v-btn>
        <v-btn color="primary" dark class=" mr-2" v-if="!queryMode" @click="doSave">
          Save
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-card>
      <v-dialog v-model="helplist" width="800px">
        <helplist
          :key="helplist"
          :apiURI="helplistURI"
          :fieldList="helplistFields"
          :fieldKey1="helplistFieldKey1"
          :fieldKey2="helplistFieldKey2"
          :expand="helplistExpand"
          @select="doSelect($event)"
          @close="helplist = false"
        ></helplist>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { formatDisplayDate } from '@/utils/date'
import { extractMenu } from '@/utils/extract'
import Helplist from '../../helplist/helplist'
export default {
  data() {
    return {
      labels: {
        branch: 'Branch',
        fund: 'Fund',
        acctNoSfx: 'Account No. Suffix',
        glAcctNoDebtCtrl: 'Debtors Control',
        glAcctNoDiffEx: 'Difference Exchange - Realised',
        glAcctNoRevalue: 'Difference Exchange - Revalue',
        glAcctNoWoff: 'Write-Off',
        glAcctNoInGst: 'Input GST',
        glAcctNoOutGst: 'Output GST',
        glAcctNoInstal: 'Instalment',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      glDebtCtrlForm: {
        branch: null,
        brnDesc: null,
        fund: null,
        fundDesc: null,
        acctNoSfx: null,
        acctNoSfxDesc: null,
        glAcctNoDebtCtrl: null,
        glAcctNoDiffEx: null,
        glAcctNoRevalue: null,
        glAcctNoWoff: null,
        glAcctNoInGst: null,
        glAcctNoOutGst: null,
        glAcctNoInstal: null,
        createdBy: null,
        createdDate: null,
        modifiedBy: null,
        modifiedDate: null
      },
      helplist: false,
      helplistMenu: null,
      helplistURI: null,
      helplistFields: null,
      helplistFieldKey1: null,
      helplistFieldKey2: null,
      helplistExpand: null,
      queryMode: false,
      reviewMode: false
    }
  },
  created() {
    if (this.glDebtCtrlMode === 'Review') {
      this.reviewMode = true
    } else if (this.glDebtCtrlMode === 'Query') {
      this.queryMode = true
    }
  },
  methods: {
    async loadHelplist() {
      const apiURI = this.menu.glDebtCtrlHelplist
      if (apiURI) {
        const result = await this.$http.get(apiURI)
        const { data } = result
        if (data) {
          this.helplistMenu = extractMenu(data._links)
        }
      }
    },
    async doInit() {
      await this.loadHelplist()
      if (!this.newGLDebtCtrl) {
        const apiURI = this.menu.getGLDebtCtrl
        if (apiURI) {
          try {
            const id = this.id.split('_')
            const expand = {
              branch: id[0],
              fund: id[1],
              acctNoSfx: id[2]
            }
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.glDebtCtrlForm.branch = data.glDebtCtrl.branch
              if (data.branch) {
                this.glDebtCtrlForm.brnDesc = data.branch.brnDesc
              }
              this.glDebtCtrlForm.fund = data.glDebtCtrl.fund
              if (data.fund) {
                this.glDebtCtrlForm.fundDesc = data.fund.fundDesc
              }
              this.glDebtCtrlForm.acctNoSfx = data.glDebtCtrl.acctNoSfx
              if (data.acctNoSfx) {
                this.glDebtCtrlForm.acctNoSfxDesc = data.acctNoSfx.description
              }
              this.glDebtCtrlForm.glAcctNoDebtCtrl = data.glDebtCtrl.glAcctNoDebtCtrl
              this.glDebtCtrlForm.glAcctNoDiffEx = data.glDebtCtrl.glAcctNoDiffEx
              this.glDebtCtrlForm.glAcctNoRevalue = data.glDebtCtrl.glAcctNoRevalue
              this.glDebtCtrlForm.glAcctNoWoff = data.glDebtCtrl.glAcctNoWoff
              this.glDebtCtrlForm.glAcctNoInGst = data.glDebtCtrl.glAcctNoInGst
              this.glDebtCtrlForm.glAcctNoOutGst = data.glDebtCtrl.glAcctNoOutGst
              this.glDebtCtrlForm.glAcctNoInstal = data.glDebtCtrl.glAcctNoInstal
              this.glDebtCtrlForm.createdBy = data.createdBy
              this.glDebtCtrlForm.createdDate = data.createdDate
              this.glDebtCtrlForm.modifiedBy = data.modifiedBy
              this.glDebtCtrlForm.modifiedDate = data.modifiedDate
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          }
        }
      } else {
        this.glDebtCtrlForm.branch = this.$store.state.token.userBranch
        this.glDebtCtrlForm.fund = ''
        this.glDebtCtrlForm.acctNoSfx = ''
        this.glDebtCtrlForm.glAcctNoDebtCtrl = null
        this.glDebtCtrlForm.glAcctNoDiffEx = null
        this.glDebtCtrlForm.glAcctNoRevalue = null
        this.glDebtCtrlForm.glAcctNoWoff = null
        this.glDebtCtrlForm.glAcctNoInGst = null
        this.glDebtCtrlForm.glAcctNoOutGst = null
        this.glDebtCtrlForm.createdBy = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.glDebtCtrlForm.createdDate = new Date()
      }
    },
    doHelplist(field) {
      if (!this.queryMode) {
        this.resetMessages()
        if (field) {
          switch (field) {
            case 'branch': {
              this.helplistURI = this.helplistMenu.branchHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'Description', value: 'brnDesc' }
              ]
              this.helplistExpand = null
              this.helplistFieldKey1 = 'branch'
              this.helplistFieldKey2 = null
              this.helplist = true
              break
            }
            case 'fund': {
              this.helplistURI = this.helplistMenu.fundHelplist
              this.helplistFields = [
                { text: 'Fund', value: 'fund' },
                { text: 'Description', value: 'fundDesc' }
              ]
              this.helplistExpand = null
              this.helplistFieldKey1 = 'fund'
              this.helplistFieldKey2 = null
              this.helplist = true
              break
            }
            case 'acctNoSfx': {
              this.helplistURI = this.helplistMenu.acctNoSfxHelplist
              this.helplistFields = [
                { text: 'Account No. Suffix', value: 'acctNoSfx' },
                { text: 'Description', value: 'description' }
              ]
              this.helplistExpand = null
              this.helplistFieldKey1 = 'acctNoSfx'
              this.helplistFieldKey2 = null
              this.helplist = true
              break
            }
            case 'glAcctNoDebtCtrl': {
              this.helplistURI = this.helplistMenu.glAcctNoHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'GL Account No.', value: 'glacctNo' },
                { text: 'Fund', value: 'fund' },
                { text: 'Account No. Suffix', value: 'acctNoSfx' }
              ]
              this.helplistFieldKey1 = 'glAcctNoDebtCtrl'
              this.helplistFieldKey2 = 'glAcctNo'
              this.helplistExpand = {
                branch: this.glDebtCtrlForm.branch,
                fund: this.glDebtCtrlForm.fund,
                acctNoSfx: this.glDebtCtrlForm.acctNoSfx
              }
              this.helplist = true
              break
            }
            case 'glAcctNoDiffEx': {
              this.helplistURI = this.helplistMenu.glAcctNoHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'GL Account No.', value: 'glacctNo' },
                { text: 'Fund', value: 'fund' },
                { text: 'Account No. Suffix', value: 'acctNoSfx' }
              ]
              this.helplistFieldKey1 = 'glAcctNoDiffEx'
              this.helplistFieldKey2 = 'glAcctNo'
              this.helplistExpand = {
                branch: this.glDebtCtrlForm.branch,
                fund: this.glDebtCtrlForm.fund,
                acctNoSfx: this.glDebtCtrlForm.acctNoSfx
              }
              this.helplist = true
              break
            }
            case 'glAcctNoRevalue': {
              this.helplistURI = this.helplistMenu.glAcctNoHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'GL Account No.', value: 'glacctNo' },
                { text: 'Fund', value: 'fund' },
                { text: 'Account No. Suffix', value: 'acctNoSfx' }
              ]
              this.helplistFieldKey1 = 'glAcctNoRevalue'
              this.helplistFieldKey2 = 'glAcctNo'
              this.helplistExpand = {
                branch: this.glDebtCtrlForm.branch,
                fund: this.glDebtCtrlForm.fund,
                acctNoSfx: this.glDebtCtrlForm.acctNoSfx
              }
              this.helplist = true
              break
            }
            case 'glAcctNoWoff': {
              this.helplistURI = this.helplistMenu.glAcctNoHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'GL Account No.', value: 'glacctNo' },
                { text: 'Fund', value: 'fund' },
                { text: 'Account No. Suffix', value: 'acctNoSfx' }
              ]
              this.helplistFieldKey1 = 'glAcctNoWoff'
              this.helplistFieldKey2 = 'glAcctNo'
              this.helplistExpand = {
                branch: this.glDebtCtrlForm.branch,
                fund: this.glDebtCtrlForm.fund,
                acctNoSfx: this.glDebtCtrlForm.acctNoSfx
              }
              this.helplist = true
              break
            }
            case 'glAcctNoInGst': {
              this.helplistURI = this.helplistMenu.glAcctNoHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'GL Account No.', value: 'glacctNo' },
                { text: 'Fund', value: 'fund' },
                { text: 'Account No. Suffix', value: 'acctNoSfx' }
              ]
              this.helplistFieldKey1 = 'glAcctNoInGst'
              this.helplistFieldKey2 = 'glAcctNo'
              this.helplistExpand = {
                branch: this.glDebtCtrlForm.branch,
                fund: this.glDebtCtrlForm.fund,
                acctNoSfx: this.glDebtCtrlForm.acctNoSfx
              }
              this.helplist = true
              break
            }
            case 'glAcctNoOutGst': {
              this.helplistURI = this.helplistMenu.glAcctNoHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'GL Account No.', value: 'glacctNo' },
                { text: 'Fund', value: 'fund' },
                { text: 'Account No. Suffix', value: 'acctNoSfx' }
              ]
              this.helplistFieldKey1 = 'glAcctNoOutGst'
              this.helplistFieldKey2 = 'glAcctNo'
              this.helplistExpand = {
                branch: this.glDebtCtrlForm.branch,
                fund: this.glDebtCtrlForm.fund,
                acctNoSfx: this.glDebtCtrlForm.acctNoSfx
              }
              this.helplist = true
              break
            }
            case 'glAcctNoInstal': {
              this.helplistURI = this.helplistMenu.glAcctNoHelplist
              this.helplistFields = [
                { text: 'Branch', value: 'branch' },
                { text: 'GL Account No.', value: 'glacctNo' },
                { text: 'Fund', value: 'fund' },
                { text: 'Account No. Suffix', value: 'acctNoSfx' }
              ]
              this.helplistFieldKey1 = 'glAcctNoInstal'
              this.helplistFieldKey2 = 'glAcctNo'
              this.helplistExpand = {
                branch: this.glDebtCtrlForm.branch,
                fund: this.glDebtCtrlForm.fund,
                acctNoSfx: this.glDebtCtrlForm.acctNoSfx
              }
              this.helplist = true
              break
            }
          }
        }
      }
    },
    doSelect(result) {
      if (result && result.fieldKey1 && result.data) {
        switch (result.fieldKey1) {
          case 'branch': {
            this.glDebtCtrlForm.branch = result.data.branch
            this.glDebtCtrlForm.brnDesc = result.data.brnDesc
            break
          }
          case 'fund': {
            this.glDebtCtrlForm.fund = result.data.fund
            this.glDebtCtrlForm.fundDesc = result.data.fundDesc
            break
          }
          case 'acctNoSfx': {
            this.glDebtCtrlForm.acctNoSfx = result.data.acctNoSfx
            this.glDebtCtrlForm.acctNoSfxDesc = result.data.description
            break
          }
          case 'glAcctNoDebtCtrl': {
            this.glDebtCtrlForm.glAcctNoDebtCtrl = result.data.glacctNo
            break
          }
          case 'glAcctNoDiffEx': {
            this.glDebtCtrlForm.glAcctNoDiffEx = result.data.glacctNo
            break
          }
          case 'glAcctNoRevalue': {
            this.glDebtCtrlForm.glAcctNoRevalue = result.data.glacctNo
            break
          }
          case 'glAcctNoWoff': {
            this.glDebtCtrlForm.glAcctNoWoff = result.data.glacctNo
            break
          }
          case 'glAcctNoInGst': {
            this.glDebtCtrlForm.glAcctNoInGst = result.data.glacctNo
            break
          }
          case 'glAcctNoOutGst': {
            this.glDebtCtrlForm.glAcctNoOutGst = result.data.glacctNo
            break
          }
          case 'glAcctNoInstal': {
            this.glDebtCtrlForm.glAcctNoInstal = result.data.glacctNo
            break
          }
        }
      }
    },
    async doCheck(field) {
      const valid = await this.$validator.validate(field)
      if (valid && this.glDebtCtrlForm[field]) {
        let desc = null
        let desc2 = null
        let apiURI = null
        let expand = {}
        switch (field) {
          case 'branch': {
            desc = 'brnDesc'
            apiURI = this.helplistMenu.branch
            expand.branch = this.glDebtCtrlForm.branch
            break
          }
          case 'fund': {
            desc = 'fundDesc'
            apiURI = this.helplistMenu.fund
            expand.fund = this.glDebtCtrlForm.fund
            break
          }
          case 'acctNoSfx': {
            desc = 'acctNoSfxDesc'
            desc2 = 'description'
            apiURI = this.helplistMenu.acctNoSfx
            expand.acctNoSfx = this.glDebtCtrlForm.acctNoSfx
            break
          }
        }
        this.glDebtCtrlForm[desc] = null
        if (!desc2) {
          desc2 = desc
        }
        if (apiURI) {
          try {
            const result = await this.$http.get(expandURI(apiURI, expand))
            const { data } = result.data
            if (data) {
              this.glDebtCtrlForm[desc] = data[field][desc2]
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
              this.glDebtCtrlForm[field] = null
            }
          }
        }
      }
    },
    async doCheckGLAcctNo(field) {
      const valid = await this.$validator.validate(field)
      if (valid && this.glDebtCtrlForm[field]) {
        const apiURI = this.helplistMenu.glAcctNo
        if (apiURI) {
          try {
            const expand = {
              branch: this.glDebtCtrlForm.branch,
              glAcctNo: this.glDebtCtrlForm[field],
              fund: this.glDebtCtrlForm.fund,
              acctNoSfx: this.glDebtCtrlForm.acctNoSfx
            }
            await this.$http.get(expandURI(apiURI, expand))
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
              this.glDebtCtrlForm[field] = null
            }
          }
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          const config = {
            method: this.newGLDebtCtrl ? 'post' : 'put',
            url: this.newGLDebtCtrl ? this.menu.createGLDebtCtrl : this.menu.updateGLDebtCtrl,
            data: this.glDebtCtrlForm
          }
          if (config.url) {
            this.$http
              .request(config)
              .then((result) => {
                const { data } = result
                this.notify(data)
                this.$router.push({ name: 'glDebtCtrl' })
              })
              .catch((err) => {
                const { data } = err.response
                if (data) {
                  this.message(data)
                  this.fieldMessage(data)
                }
              })
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'glDebtCtrl' })
    }
  },
  computed: {
    newGLDebtCtrl() {
      return this.id === 'new'
    },
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glDebtCtrlMode() {
      return this.$route.params.glDebtCtrlMode
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return null
      }
    }
  },
  components: {
    Helplist
  },
  mixins: [MessageMixin],
  props: ['id']
}
</script>

<style>
</style>
